import { render, staticRenderFns } from "./liability.vue?vue&type=template&id=6f63d25c"
import script from "./liability.vue?vue&type=script&lang=js"
export * from "./liability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports